module.exports = __webpack_public_path__ + "img/1508889832.f7945b64.jpg";